module.exports = __webpack_public_path__ + "static/payment-methods-6faa31127b431f536b35c43e04a6a77e.svg";